var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconBarGraph = function SvgIconBarGraph(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.515 3.515a12 12 0 1 1 16.97 16.97 12 12 0 0 1-16.97-16.97ZM11.999 2a10 10 0 1 0 0 19.999A10 10 0 0 0 12 2Zm3.667 8.266a1 1 0 0 1 1 1v4.866h.467a1 1 0 1 1 0 2H6.867a1 1 0 0 1-1-1v-8.8a1 1 0 0 1 2 0v7.8h.932V12a1 1 0 1 1 2 0v4.133h.934V9.8a1 1 0 1 1 2 0v6.333h.933v-4.866a1 1 0 0 1 1-1Z",
    fill: "currentColor"
  })));
};
export default SvgIconBarGraph;